import appConfig from "@/app.config";

const schema = {
  tabs: [
    {
      title: 'Locations',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Content",
      side_panel: {},
      form: {
        page_description: {
          type: 'ckeditor',
          label: 'Description',
          placeholder: '',
          required: true,
          info: false,
          character_count: 2000,
          disabled: false,
          wrapper_class: ''
        }
      }
    },
    {
      title: 'Locations',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Locations",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Location',
      formData: {},
      schema: {
      name: {
        type: 'text',
        label: 'Topic Name',
        placeholder: 'Enter Topic Name',
        required: true,
        info: false,
        character_count: 50
        },
      },
      side_panel: {
        select_a_day: {
          type: 'list',
          label: 'Select a Location',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [],
          draggable: true
        }
      },
      form: {
        location_name: {
            type: 'text',
            label: 'Location Name',
            placeholder: 'Enter Location Name',
            required: true,
            info: true,
            character_count: 250,
            disabled: false,
            wrapper_class: ''
          },
          address: {
            type: 'text',
            label: 'Address',
            placeholder: 'Enter Address',
            required: false,
            info: true,
            character_count: 0,
            disabled: false,
            wrapper_class: ''
          },

      }
    }
  ]
};

export { schema };